import i18n from 'i18next'

let currentLanguage = i18n.language || 'en'
let listeners = []

export function languageUtil() {
    const language = currentLanguage

    const setLanguage = lang => {
        currentLanguage = lang
        localStorage.setItem('language', lang)
        i18n.changeLanguage(lang)
        listeners.forEach(listener => listener(lang))
    }

    return { language, setLanguage }
}

export function onLanguageChange(listener) {
    listeners.push(listener)
    return () => {
        listeners = listeners.filter(l => l !== listener)
    }
}

// Wait until i18n is ready before changing language
i18n.on('initialized', () => {
    const savedLang = localStorage.getItem('language')
    if (savedLang && savedLang !== currentLanguage) {
        currentLanguage = savedLang
        i18n.changeLanguage(savedLang)
    }
})
